import { Component } from '@angular/core';
import { SkeletonModule } from 'primeng/skeleton';

@Component({
  selector: 'app-upload-skeleton',
  imports: [SkeletonModule],
  templateUrl: './upload-skeleton.component.html',
  styleUrl: './upload-skeleton.component.scss'
})
export class UploadSkeletonComponent {}
